import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 30,
	viewBox: "0 0 25 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1982 8.79688C17.3089 8.79688 21.3984 12.9596 21.3984 18.2969C21.3984 19.6951 21.0287 21.0176 20.3496 22.5742C20.347 22.5775 20.3428 22.583 20.3359 22.5898C20.3198 22.606 20.2962 22.6258 20.2666 22.6436C20.2254 22.6683 20.1837 22.6808 20.1484 22.6885C20.1237 22.6763 20.0876 22.6591 20.0488 22.6445C20.0287 22.637 20.0043 22.6295 19.9766 22.6221C19.894 22.571 19.8505 22.5154 19.833 22.4746C19.8169 22.4368 19.8106 22.3905 19.8457 22.3203L19.8525 22.3076L19.8584 22.2939C20.4768 20.851 20.7988 19.5829 20.7988 18.1973C20.7988 13.4212 16.8747 9.49717 12.0986 9.49707C7.32248 9.49707 3.39844 13.4211 3.39844 18.1973C3.39849 19.7588 3.71061 21.1547 4.37012 22.2539L4.37598 22.2646L4.38281 22.2744C4.39184 22.2883 4.40897 22.3361 4.39062 22.4053C4.37392 22.4679 4.33428 22.5199 4.27441 22.5498L4.24707 22.5635L4.2207 22.5811C4.20676 22.5901 4.15905 22.6073 4.08984 22.5889C4.02725 22.5722 3.97526 22.5334 3.94531 22.4736L3.94238 22.4668L3.93848 22.46L3.81836 22.2285C3.23346 21.0581 2.89844 19.7106 2.89844 18.0967C2.89855 12.973 7.07454 8.79699 12.1982 8.79688Z",
			fill: "#8E68F7",
			stroke: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1006 13.2031C13.9244 13.2031 15.4003 14.6791 15.4004 16.5029C15.4004 18.3268 13.9244 19.8027 12.1006 19.8027C10.2768 19.8026 8.80078 18.3267 8.80078 16.5029C8.8009 14.6792 10.2769 13.2032 12.1006 13.2031Z",
			fill: "#8E68F7",
			stroke: "#8E68F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2119 22.2988C14.5043 22.2511 15.7322 22.918 16.4023 23.6201C17.0711 24.3209 17.2527 25.129 17.3008 25.5293C17.3007 25.5574 17.3006 25.5793 17.2998 25.5986C15.6764 26.6425 13.9791 27.1992 12.2012 27.1992C10.3203 27.1991 8.54452 26.6403 7.14355 25.6289C7.13709 25.6184 7.13052 25.605 7.12402 25.5898C7.11242 25.5628 7.10617 25.5384 7.10352 25.5195C7.19684 24.7597 7.58089 23.9739 8.3584 23.3691C9.15009 22.7534 10.3835 22.2999 12.2012 22.2998L12.2119 22.2988Z",
			fill: "#8E68F7",
			stroke: "#8E68F7"
		})
	]
});
export default SvgProfileSolid;
